module.exports = __webpack_public_path__ + "img/bobaoqi.611928b1.jpg";